export const sideNavTourStyles = {
    options: {
        zIndex: 2000,
        primaryColor: "#0090FE",
    },
    buttonNext: {
        backgroundColor: "#0090FE",
        fontSize: "14px",
        fontWeight: 600,
        padding: "10px 16px",
        borderRadius: "8px",
    },
    buttonBack: {
        color: "#0090FE",
        fontSize: "14px",
    },
    buttonSkip: {
        color: "#0090FE",
        fontSize: "14px",
    },
    tooltipContent: {
        fontSize: "15px",
        textAlign: "left",
    },
};